var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24942 2.24942C0 4.49885 0 8.11923 0 15.36V16.64C0 23.8808 0 27.5012 2.24942 29.7506C4.49885 32 8.11923 32 15.36 32H16.64C23.8808 32 27.5012 32 29.7506 29.7506C32 27.5012 32 23.8808 32 16.64V15.36C32 8.11923 32 4.49885 29.7506 2.24942C27.5012 0 23.8808 0 16.64 0H15.36C8.11923 0 4.49885 0 2.24942 2.24942ZM5.40006 9.73341C5.57338 18.0534 9.73334 23.0534 17.0267 23.0534H17.4401V18.2934C20.1201 18.56 22.1466 20.5201 22.9599 23.0534H26.7467C25.7067 19.2667 22.9732 17.1734 21.2666 16.3734C22.9732 15.3867 25.3733 12.9867 25.9466 9.73341H22.5065C21.7598 12.3734 19.5468 14.7734 17.4401 15V9.73341H14V18.96C11.8667 18.4267 9.17338 15.8401 9.05338 9.73341H5.40006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVk);
export default __webpack_public_path__ + "static/media/IconVK.4481f76a38140e47c2cc566e2d908d98.svg";
export { ForwardRef as ReactComponent };